var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVet8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150.000000pt",
    height: "150.000000pt",
    viewBox: "0 0 150.000000 150.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,150.000000) scale(0.100000,-0.100000)",
    fill: "#D00202",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M695 1486 c-33 -15 -62 -44 -79 -79 -9 -16 -22 -23 -53 -25 -25 -2 -48 -11 -58 -23 -16 -17 -32 -19 -162 -19 l-145 0 -29 -29 -29 -29 0 -606 0 -606 29 -32 29 -33 552 0 552 0 29 33 29 32 0 606 0 606 -29 29 -29 29 -145 0 c-131 0 -145 2 -162 20 -12 13 -31 20 -56 20 -34 0 -42 5 -64 40 -14 22 -36 47 -50 56 -34 22 -94 27 -130 10z m90 -50 c37 -16 55 -42 55 -80 0 -25 2 -26 60 -26 l60 0 0 -50 0 -50 -210 0 -210 0 0 50 0 50 60 0 c58 0 60 1 60 26 0 38 18 64 53 79 40 18 32 17 72 1z m-295 -176 l0 -30 -104 0 c-82 0 -108 -3 -120 -16 -14 -14 -16 -75 -16 -529 0 -282 3 -520 6 -529 5 -14 58 -16 494 -16 436 0 489 2 494 16 3 9 6 247 6 529 0 454 -2 515 -16 529 -12 13 -38 16 -120 16 l-104 0 0 30 0 30 138 0 c94 0 142 -4 150 -12 9 -9 12 -157 12 -604 l0 -593 -22 -15 c-20 -14 -88 -16 -538 -16 -450 0 -518 2 -538 16 l-22 15 0 593 c0 447 3 595 12 604 8 8 56 12 150 12 l138 0 0 -30z m705 -580 l0 -485 -445 0 -445 0 -3 475 c-1 261 0 481 3 488 3 10 98 12 447 10 l443 -3 0 -485z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726 1387 c-38 -27 2 -95 42 -71 24 16 28 55 6 71 -10 7 -21 13 -24 13 -3 0 -14 -6 -24 -13z m39 -26 c7 -12 -12 -24 -25 -16 -11 7 -4 25 10 25 5 0 11 -4 15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 1045 c-84 -43 -132 -122 -132 -217 1 -136 103 -238 240 -238 146 0 249 112 238 259 -9 124 -101 212 -227 219 -56 3 -74 -1 -119 -23z m181 -39 c71 -31 117 -100 117 -176 0 -110 -80 -190 -190 -190 -110 0 -190 80 -190 190 0 134 142 229 263 176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 852 l-66 -66 -26 24 c-23 22 -27 22 -41 8 -14 -14 -13 -19 16 -52 18 -20 40 -36 49 -36 21 0 161 140 161 162 0 36 -30 23 -93 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 461 c-15 -23 7 -41 48 -41 45 0 68 14 59 36 -6 16 -98 20 -107 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 455 c-13 -32 7 -35 216 -35 181 0 209 2 214 16 3 9 4 20 0 25 -3 5 -100 9 -215 9 -174 0 -211 -2 -215 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 315 c-10 -24 5 -35 50 -35 45 0 68 14 59 36 -7 20 -102 19 -109 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613 315 c-3 -9 -1 -21 4 -26 5 -5 95 -8 219 -7 201 3 209 4 209 23 0 19 -8 20 -213 23 -186 2 -213 0 -219 -13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVet8);
export default __webpack_public_path__ + "static/media/vet-8.6d750c7b101f9b973967a102e33c464e.svg";
export { ForwardRef as ReactComponent };